import type { PickupDeliveryResponse, ReschedulePhase } from '../../services/ordersApi';

interface Props {
  phase: ReschedulePhase | null;
  legs: PickupDeliveryResponse[] | undefined;
}

const DONE = ['CANCELLED', 'COMPLETED'];

/** The leg a reschedule in this phase would release, when a driver is on it. */
function releasedLeg(phase: ReschedulePhase | null, legs: PickupDeliveryResponse[] | undefined) {
  const type = phase === 'RETURN' ? 'RETURN_DELIVERY' : 'PICKUP';
  const leg = legs?.find((l) => l.type === type && !DONE.includes(l.status));
  return leg && (leg.driverName || leg.providerId) ? leg : null;
}

/** What the confirm will do, said before it does it (style of RefundConsequence). */
export default function RescheduleConsequence({ phase, legs }: Props) {
  const leg = releasedLeg(phase, legs);
  const which = phase === 'RETURN' ? 'Drop-off' : 'Pickup';
  return (
    <div data-testid="reschedule-consequence" style={{ fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '1rem' }}>
      <div className="admin-form-label">What happens</div>
      <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
        {leg && (
          <li data-testid="reschedule-driver-release">
            {phase === 'RETURN' ? '' : 'If the pickup date or time changes, the '}
            {phase === 'RETURN' ? which : which.toLowerCase()} driver {leg.driverName ?? ''} will be released and told by WhatsApp. Assign a driver again afterwards.
          </li>
        )}
        <li>Customer gets a push and a WhatsApp.</li>
        <li>Garage gets WhatsApp + email.</li>
      </ul>
    </div>
  );
}
